import { setApplyInputLimit } from './open-payment-balance-apply';
import { sumPledgeAmountPaidInputs } from './pledge-pay-amount';
import { formatCurrency } from './pledge-pay-utils';

function mgrPledgeModalSyncOpenPaymentApplyControls($modal) {
    const $wrap = $modal.find('#mgr_open_payment_amount_wrap');
    const $inp = $modal.find('#mgr_open_payment_apply_amount');
    const $cb = $modal.find('#mgr_use_open_payment_balance');
    if (!$inp.length || !$cb.length) {
        return;
    }
    const checked = $cb.prop('checked');
    $inp.prop('disabled', !checked);
    $wrap.toggleClass('mgr-open-credit-apply-muted', !checked);
}

function mgrPledgeModalSyncOpenPaymentEmptyPanelLayout($modal, emptyShown) {
    $modal
        .find('#mgr_open_payment_empty_state')
        .parent()
        .toggleClass('mgr-pledge-panel--open-payment-empty', !!emptyShown);
}

function syncOpenPaymentStatesSingle($modal, getOpenBalanceAvailable) {
    const t = getOpenBalanceAvailable();
    if (t <= 0) {
        $modal.find('#mgr_open_payment_empty_state').show();
        $modal.find('#mgr_open_payment_active_state').hide();
        $modal.find('#mgr_open_payment_zero_display').text(formatCurrency(0));
        mgrPledgeModalSyncOpenPaymentEmptyPanelLayout($modal, true);
        return;
    }
    $modal.find('#mgr_open_payment_empty_state').hide();
    $modal.find('#mgr_open_payment_active_state').show();
    $modal.find('#mgr_open_payment_available_amt').text(formatCurrency(t));
    mgrPledgeModalSyncOpenPaymentApplyControls($modal);
    mgrPledgeModalSyncOpenPaymentEmptyPanelLayout($modal, false);
}

function recalcOpenApplyCapSingle($modal, getOpenBalanceAvailable) {
    const amtDue = sumPledgeAmountPaidInputs($modal);
    const openAvail = getOpenBalanceAvailable();
    const $inp = $modal.find('#mgr_open_payment_apply_amount');
    if ($inp.length) {
        setApplyInputLimit($inp, openAvail, amtDue);
    }
}

function computeBalanceAppliedSingle($modal, getOpenBalanceAvailable) {
    const openBalAvailable = getOpenBalanceAvailable();
    const $openActive = $modal.find('#mgr_open_payment_active_state');
    const $openEmpty = $modal.find('#mgr_open_payment_empty_state');
    const openPanelShowsActive = openBalAvailable > 0.005
        && $openActive.length
        && (!$openEmpty.length || $openEmpty.css('display') === 'none')
        && $openActive.css('display') !== 'none';
    const useBal = openPanelShowsActive && $modal.find('#mgr_use_open_payment_balance').prop('checked');
    if (!useBal) {
        return 0;
    }
    const tableTotal = sumPledgeAmountPaidInputs($modal);
    const applyRaw = parseFloat(String($modal.find('#mgr_open_payment_apply_amount').val()).replace(/,/g, '')) || 0;
    const maxApply = Math.min(tableTotal, openBalAvailable);
    return Math.min(Math.max(0, applyRaw), maxApply);
}

export {
    computeBalanceAppliedSingle,
    mgrPledgeModalSyncOpenPaymentApplyControls,
    mgrPledgeModalSyncOpenPaymentEmptyPanelLayout,
    recalcOpenApplyCapSingle,
    syncOpenPaymentStatesSingle,
};
